
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function OccupationalCertificatesSection() {
  const [isExpanded, setIsExpanded] = useState(true);

  const programmes = [
    {
      title: 'Occupational Certificate: Retail Buyer',
      saqaId: '103145',
      nqfLevel: '5',
      credits: '131'
    },
    {
      title: 'Occupational Certificate: Retail Chain Store Manager',
      saqaId: '103150',
      nqfLevel: '5',
      credits: '106'
    },
    {
      title: 'Occupational Certificate: Retail Supervisor',
      saqaId: '99573',
      nqfLevel: '4',
      credits: '100'
    },
    {
      title: 'Occupational Certificate: Sales Assistant (General) (Retail Sales Advisor)',
      saqaId: '99669',
      nqfLevel: '3',
      credits: '54'
    },
    {
      title: 'Occupational Certificate: Store Person',
      saqaId: '99703',
      nqfLevel: '2',
      credits: '41'
    }
  ];

  return (
    <div className="mb-12">
      <div 
        className="bg-white rounded-lg shadow-md border border-gray-200 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-[#1A1A1A] mb-2">
              Occupational Certificates (QCTO)
            </h2>
            <p className="text-gray-600">
              Nationally recognised qualifications for career advancement
            </p>
          </div>
          <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-2xl text-[#2D7F3E]`}></i>
        </div>
      </div>

      {isExpanded && (
        <div className="mt-4 bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#F5F5F5]">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#1A1A1A]">Qualification / Programme Title</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#1A1A1A]">SAQA ID / OFO Code</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#1A1A1A]">NQF Level</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#1A1A1A]">Credits</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#1A1A1A]">Action</th>
                </tr>
              </thead>
              <tbody>
                {programmes.map((programme, index) => (
                  <tr key={index} className="border-t border-gray-200 hover:bg-[#F9F9F9]">
                    <td className="px-6 py-4 text-sm text-[#1A1A1A] font-medium">{programme.title}</td>
                    <td className="px-6 py-4 text-sm text-gray-600 font-mono">{programme.saqaId}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{programme.nqfLevel}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{programme.credits}</td>
                    <td className="px-6 py-4">
                      <Link
                        to={`/contact?programme=${encodeURIComponent(programme.title)}`}
                        className="inline-flex items-center justify-center bg-[#2D7F3E] text-white px-4 py-2 rounded-lg hover:bg-[#245A2E] transition-colors text-sm font-medium whitespace-nowrap"
                      >
                        Apply Now
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
